import React from "react";
import { Controller } from "react-hook-form";
import { Link } from "react-router-dom";
import { USERS_LOV } from "../../../apollo/queries";
import useCreateStore from "../../../controllers/useCreateStore";
import Dropdown from "../../../feature-module/components/Dropdown";
import ErrorMessage from "../../../feature-module/components/errorMessage";
import InputField from "../../../feature-module/components/InputField";

const StoreModal = () => {

  const { values, functions } = useCreateStore();

  return (
    <>
      {/* Add Store */}
      <div className="modal fade" id="add-units">
        <div className="modal-dialog modal-dialog-centered custom-modal-two">
          <div className="modal-content">
            <div className="page-wrapper-new p-0">
              <div className="content">
                <div className="modal-header border-0 custom-modal-header">
                  <div className="page-title">
                    <h4>Create Store</h4>
                  </div>
                  <button
                    type="button"
                    className="close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={functions.onCancel}
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body custom-modal-body new-employee-field">
                  <form>
                    <div className="mb-3">
                      <Controller
                        name="name"
                        control={values.control}
                        rules={{ required: "Name is required" }}
                        render={({ field }) => (
                          <InputField
                            label="Store Name"
                            type="text"
                            required
                            placeholder="Enter Store Name"
                            {...field}
                          />
                        )}
                      />
                      <ErrorMessage error={values.errors.name?.message} />
                    </div>
                    <div className="mb-3">
                      <Controller
                        name="owner_id"
                        control={values.control}
                        rules={{ required: "Store Owner is required" }}
                        render={({ field }) => (
                          <Dropdown
                            query={USERS_LOV}
                            dataKey="listUserByRole"
                            variables={{
                              role: values.roles,
                            }}
                            label="Store Owner"
                            required
                            placeholder="Select Store Owner"
                            field={field}
                          // onChange={handleChangeWarehouse}
                          />
                        )}
                      />
                      <ErrorMessage
                        error={values.errors.owner_id?.message}
                      />
                    </div>
                    <label className="form-label">Logo <span className="text-danger">*</span></label>
                    <Controller
                      name="image"
                      control={values.control}
                      rules={{
                        required: "Logo is required",
                        validate: {
                          checkFileType: (value) => {
                            return (
                              value?.type === "image/jpeg" ||
                              value?.type === "image/png" ||
                              "Only JPEG and PNG formats are allowed"
                            );
                          },
                          checkFileSize: (value) => {
                            return (
                              value?.size < 5000000 ||
                              "Image must be smaller than 5MB"
                            );
                          },
                        },
                      }}
                      render={({ field }) => (
                        <div className="profile-pic-upload mb-3">
                          <div className="profile-pic brand-pic">
                            {field.value ? (
                              <img
                                src={URL.createObjectURL(field.value)}
                                alt="Profile Preview"
                                className="image-preview"
                                style={{
                                  width: "100px",
                                  height: "100px",
                                  objectFit: "cover",
                                }}
                              />
                            ) : (
                              <span>Select Image</span>
                            )}
                          </div>
                          <div className="image-upload mb-0">
                            <input
                              type="file"
                              accept="image/*"
                              onChange={(e) =>
                                field.onChange(e.target.files[0])
                              }
                              ref={field.ref}
                            />
                            <div className="image-uploads">
                              <h4>{field.value ? "Change" : "Add"} Image</h4>
                            </div>
                          </div>
                        </div>
                      )}
                    />
                    {values.errors.image && (
                      <ErrorMessage error={values.errors.image.message} />
                    )}
                    <div className="mb-0">
                      <div className="status-toggle modal-status d-flex justify-content-between align-items-center">
                        <span className="status-label">Status</span>
                        <Controller
                          name="is_active"
                          control={values.control}
                          render={({ field }) => (
                            <>
                              <input
                                type="checkbox"
                                id="add-brandstatus"
                                className="check"
                                checked={field.value}
                                onChange={(e) =>
                                  field.onChange(e.target.checked)
                                } // Update form state on change
                              />
                              <label
                                htmlFor="add-brandstatus"
                                className="checktoggle"
                              />
                            </>
                          )}
                        />
                      </div>
                    </div>
                    <div className="modal-footer-btn">
                      <button
                        type="button"
                        className="btn btn-cancel me-2"
                        data-bs-dismiss="modal"
                        onClick={functions.onCancel}
                      >
                        Cancel
                      </button>
                      <Link
                        onClick={functions.onSubmit}
                        to="#"
                        className="btn btn-submit"
                      >
                        Create Store
                      </Link>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Add Store */}
    </>
  );
};

export default StoreModal;
